export default __webpack_public_path__ + "6c400d2825a0f38aac5b3cbba6570d96.png";